import { render } from "./Services-page.vue?vue&type=template&id=d98b42ec"
import script from "./Services-page.vue?vue&type=script&lang=js"
export * from "./Services-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__